module.exports = __webpack_public_path__ + "static/media/peter_purg_cut.bf15c040.jpg";